module.exports = __webpack_public_path__ + "img/android@3x.51d9dad7.png";